import HomeIcon from '@components/icons/IconHome';
import IconCheckList from '@components/icons/IconCheckList';
import IconCart from '@components/icons/IconCart';
import IconFullCart from '@components/icons/fullCart.icon';
import IconAddFile from '@components/icons/IconAddFile';
import IconInfo from '@components/icons/info.icon';

export const menuItems = [
  {
    id: 'home',
    name: 'Home',
    label: 'HM',
    pathname: '/home',
    icon: <HomeIcon />,
    authorizedOnly: false,
  },
  {
    id: 'newSubmission',
    name: 'New Submission',
    label: 'NS',
    pathname: '/submissions/create',
    icon: <IconAddFile />,
    authorizedOnly: true,
  },
  {
    id: 'mySubmissions',
    name: 'My Submissions',
    label: 'MS',
    pathname: '/submissions',
    icon: <IconCheckList />,
    authorizedOnly: true,
  },
  {
    id: 'newOrder',
    name: 'New Credit Purchase',
    label: 'NR',
    pathname: '/orders/create',
    icon: <IconCart />,
    authorizedOnly: true,
  },
  {
    id: 'myOrders',
    name: 'My Previous Purchases',
    label: 'OR',
    pathname: '/orders',
    icon: <IconFullCart />,
    authorizedOnly: true,
  },
  {
    id: 'info',
    name: 'Info/FAQ',
    label: 'FAQ',
    pathname: '/info',
    icon: <IconInfo />,
    authorizedOnly: true,
  },
];
